// extracted by mini-css-extract-plugin
module.exports = {"air8-file-upload_table":"list_air8-file-upload_table_379V3","air8-file-upload_table-item":"list_air8-file-upload_table-item_1SdTO","error-options":"list_error-options_2cZKK"};